export default {"src":"/_next/static/media/category-leaders-header.55a6fa40.svg","height":60,"width":254,"blurWidth":0,"blurHeight":0};